
import { useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/components/ui/use-toast";
import { Account } from "@/types/strategy-types";

export const useCreateAccount = (loadAccountsCallback: () => Promise<void>) => {
  const [isCreating, setIsCreating] = useState(false);
  const { toast } = useToast();

  const createAccount = async (newAccount: Partial<Account>) => {
    setIsCreating(true);
    try {
      // Ensure required fields are present
      if (!newAccount.external_id || !newAccount.exchange || 
          !newAccount.strategy_id || !newAccount.lead_account_id) {
        throw new Error("Missing required fields for account creation");
      }
      
      const { error } = await supabase
        .from('account')
        .insert([{
          external_id: newAccount.external_id,
          exchange: newAccount.exchange,
          strategy_id: newAccount.strategy_id,
          lead_account_id: newAccount.lead_account_id,
          is_primary: newAccount.is_primary,
          active: newAccount.active,
          performance_url: newAccount.performance_url || null
        }]);

      if (error) throw error;

      await loadAccountsCallback();
      toast({
        title: "Success",
        description: "Account created successfully",
      });
    } catch (error) {
      console.error('Error creating account:', error);
      toast({
        title: "Error",
        description: "Failed to create account",
        variant: "destructive",
      });
      throw error;
    } finally {
      setIsCreating(false);
    }
  };

  return { createAccount, isCreating };
};
